var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',[_c('div',{ref:"ctx",staticClass:"fixed z-50 flex flex-row bg-white border shadow-md divide-x rounded-md overflow-hidden",style:(_vm.position)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }